import Accordion from 'accordion-js';

const faqContainer = document.querySelector('.faq-accordion-container');
const closingTimers = new WeakMap();

const faqAccordion = new Accordion(faqContainer, {
  duration: 500,
  showMultiple: false,
  elementClass: 'ac',
  triggerClass: 'faq-btn',
  panelClass: 'ac-panel',
  activeClass: 'is-active',

  beforeOpen(currentElement) {
    clearTimeout(closingTimers.get(currentElement));
    currentElement.classList.remove('is-closing');
  },

  beforeClose(currentElement) {
    currentElement.classList.add('is-closing');

    const timer = setTimeout(() => {
      currentElement.classList.remove('is-closing');
    }, 250);

    closingTimers.set(currentElement, timer);
  },

  onClose(currentElement) {
    clearTimeout(closingTimers.get(currentElement));
    currentElement.classList.remove('is-closing');
    closingTimers.delete(currentElement);
  },
});

faqContainer.addEventListener('click', event => {

  if (event.target.closest('.faq-btn')) return;

  if (event.target.closest('a, input, textarea, select')) return;

  const activeItem = event.target.closest('.ac.is-active');

  if (!activeItem) return;

  const accordionItems = Array.from(
    faqContainer.querySelectorAll(':scope > .ac')
  );

  const activeItemIndex = accordionItems.indexOf(activeItem);

  if (activeItemIndex !== -1) {
    faqAccordion.close(activeItemIndex);
  }
});